export default "__VITE_ASSET__ChdBJlG3__"